/**
 * @desc        Firestore automation entity + sensor snapshots (manual control, device state).
 * @version     1.0.0 (Initial version) - 27 May 2026
 */

import * as actionTypes from 'redux/actions/action-types.js'

const initialState = {
    entities: {},
    sensors: {},
    lastFetch: 0,
    loading: false,
}

const automations = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return { ...initialState }
        case actionTypes.FD_AUTOMATIONS_ENTITIES_SET:
            return {
                ...state,
                lastFetch: Date.now(),
                loading: false,
                entities: action.data ?? {},
            }
        case actionTypes.FD_AUTOMATIONS_SENSORS_SET:
            return {
                ...state,
                lastFetch: Date.now(),
                loading: false,
                sensors: action.data ?? {},
            }
        default:
            return state
    }
}

export default automations
